import { Environment } from './environment.model';

export const environment: Environment = {
    production: true,
    environment: 'production',
    accountAppUrl: 'https://account.viessmann-climatesolutions.com',
    baseApiUrl: 'https://api.viessmann-climatesolutions.com',
    baseUrl: 'https://api.viessmann-climatesolutions.com',
    partnerPortalBaseUrl: 'https://partnerportal.viessmann-climatesolutions.com',
    translationsBaseUrl: 'https://api.viessmann-climatesolutions.com/translations/v2',
    apiKey: '588f843e-4173-4e74-8518-22dfdaefd17e',
    phraseappProjectId: {
        homePlanner: '8e2aa2a65cc63ba26a928b36582552c8',
        globalHeader: '30b1afd8a62ba6728e53abffe9101eb2',
        designSystemWeb: 'ec38b083a23c58c604a49d7f443dd7f2',
        flows: '5cfb7f9a03a8d6fba82d29aa840b7715'
    },
    authConfig: {
        issuer: 'https://iam.viessmann-climatesolutions.com',
        loginUrl: 'https://iam.viessmann-climatesolutions.com/idp/v3/authorize',
        logoutUrl: 'https://iam.viessmann-climatesolutions.com/idp/v3/sso/logout',
        tokenEndpoint: 'https://iam.viessmann-climatesolutions.com/idp/v3/token',
        userinfoEndpoint: 'https://iam.viessmann-climatesolutions.com/idp/v2/tokeninfo',
        redirectUri: 'https://home-planner.viessmann-climatesolutions.com/utils',
        clientId: '286aabd0e3b5b934f71bf865ab224f47',
        postLogoutRedirectUri: '',
        responseType: 'code',
        scope: 'Internal',
        oidc: false,
        clockSkewInSec: 0
    }
};
